import { buildAddOnField } from "../add-on-field";

export function createEntityPicker(schemaFormProvider, sfPathProvider) {
	return function entityPicker(name, schema, options) {
		if(schema.type !== "entity" || schema.format !== "entity") {
			return undefined;
		}

		const field = buildAddOnField(
			schemaFormProvider,
			sfPathProvider,
			name,
			schema,
			options,
			"entity",
			"./template.html"
		);
		field.schema = schema.type === schema.format
			? { ...schema, type: "number" }
			: schema;

		return field;
	};
}

export function entityAddOn(
	schemaFormDecoratorsProvider,
	sfBuilderProvider,
	schemaFormProvider,
	sfPathProvider
) {
	const entityPicker = createEntityPicker(schemaFormProvider, sfPathProvider);

	schemaFormProvider.defaults.entity = [entityPicker];

	schemaFormDecoratorsProvider.defineAddOn(
		"bootstrapDecorator",           	// Name of the decorator you want to add to.
		"entity",                      		// Form type that should render this add-on
		"./templates/entity/template.html",  		// Template name in $templateCache
		sfBuilderProvider.stdBuilders   	// List of builder functions to apply.
	);
}
